import { generateConfig } from './utils';

export const COLORS = {
  transparent: 'transparent',
  current: 'currentColor',
  black: '#000000',
  white: '#ffffff',
  primary: generateConfig('primary'),
  secondary: generateConfig('secondary'),
  blue: {
    DEFAULT: '#0081f9',
    light: '#a5d1ff',
    1: '#9ED0FE',
    2: '#77BCFD',
    3: '#4FA9FB',
    4: '#2895FA',
    5: '#0081F9',
    6: '#006CD0',
    7: '#0057A7',
    8: '#00417F',
    9: '#002C56',
    10: '#E6F3FF',
  },
  gray: {
    1: '#f6f9fc',
    2: '#e9ecef',
    3: '#dee2e6',
    4: '#ced4da',
    5: '#adb5bd',
    6: '#8898aa',
    7: '#828282',
    8: '#4f4f4f',
    9: '#333333',
  },
  red: {
    DEFAULT: '#FD0044',
    1: '#FFA2BA',
    2: '#FE799D',
    3: '#FE517F',
    4: '#FD2862',
    5: '#FD0044',
    6: '#D40039',
    7: '#AB002E',
    8: '#830023',
    9: '#5A0018',
    10: '#FFE6ED',
  },
  yellow: {
    DEFAULT: '#FCBF49',
    1: '#FEF2DB',
    2: '#FEE5B6',
    3: '#FDD992',
    4: '#FDCC6D',
    5: '#FCBF49',
    6: '#E1A93B',
    7: '#C7922D',
    8: '#AC7C1E',
    9: '#926510',
  },
  green: {
    DEFAULT: '#8CB369',
    1: '#DFEAD5',
    2: '#CADCBA',
    3: '#B6CF9F',
    4: '#A1C184',
    5: '#8CB369',
    6: '#789A59',
    7: '#64814A',
    8: '#4F673A',
    9: '#3B4E2B',
    10: '#F4F8F0',
  },
  purple: {
    DEFAULT: '#733df9',
    1: '#E3D8FE',
    2: '#C7B1FD',
    3: '#AB8AFB',
    4: '#8F63FA',
    5: '#733DF9',
    6: '#6131D7',
    7: '#4F25B5',
    8: '#3C1A92',
    9: '#2A0E70',
  },
  orange: {
    DEFAULT: '#F97316',
    1: '#FFEDD5',
    2: '#FED7AA',
    3: '#FDBA74',
    4: '#FB923C',
    5: '#F97316',
    6: '#EA580C',
    7: '#C2410C',
    8: '#9A3412',
    9: '#7C2D12',
  },
  body: '#f8f9fe',
};

export const SPACING = {
  px: '1px',
  0: '0',
  0.5: '2px',
  1: '4px',
  1.5: '6px',
  2: '8px',
  2.5: '10px',
  3: '12px',
  3.5: '14px',
  4: '16px',
  4.5: '18px',
  5: '20px',
  5.5: '22px',
  6: '24px',
  6.5: '26px',
  7: '28px',
  7.5: '30px',
  8: '32px',
  8.5: '34px',
  9: '36px',
  9.5: '38px',
  10: '40px',
  10.5: '42px',
  11: '44px',
  11.5: '46px',
  12: '48px',
  12.5: '50px',
  13: '52px',
  13.5: '54px',
  14: '56px',
  14.5: '58px',
  15: '60px',
  15.5: '62px',
  16: '64px',
  17: '68px',
  18: '72px',
  19: '76px',
  20: '80px',
  21: '84px',
  22: '88px',
  23: '92px',
  24: '96px',
  25: '100px',
  26: '104px',
  27: '108px',
  28: '112px',
  29: '116px',
  30: '120px',
  31: '124px',
  32: '128px',
  36: '144px',
  40: '160px',
  44: '176px',
  48: '192px',
  52: '208px',
  56: '224px',
  60: '240px',
  64: '256px',
  72: '288px',
  80: '320px',
  96: '384px',
};

export const EXTENDED_FONT_SIZES = {
  '3xs': ['8px', { lineHeight: '10px' }],
  '2xs': ['10px', { lineHeight: '12px' }],
  '1.5xs': ['11px', { lineHeight: '13px' }],
  xs: ['12px', { lineHeight: '14px' }],
  sm: ['14px', { lineHeight: '17px' }],
  base: ['16px', { lineHeight: '19px' }],
  lg: ['18px', { lineHeight: '21.6px' }],
  xl: ['20px', { lineHeight: '24px' }],
  '2xl': ['22px', { lineHeight: '27px' }],
  '3xl': ['24px', { lineHeight: '29px' }],
  '4xl': ['28px', { lineHeight: '34px' }],
  '5xl': ['32px', { lineHeight: '38px' }],
  '6xl': ['44px', { lineHeight: '53px' }],
} as const;

export const EXTENDED_TRACKING = {
  wide: '0.02em',
};

export const EXTENDED_BOX_SHADOW = {
  DEFAULT:
    '1px 1px 4px 0 rgba(112, 144, 176, 0.25), -3px 4px 8px rgba(112, 144, 176, 0.25)',
  xs: '1px 1px 4px 0 rgba(112, 144, 176, 0.15)',
  sm: '1px 1px 4px rgba(112, 144, 176, 0.15), -3px 4px 8px rgba(112, 144, 176, 0.15)',
  lg: '0px 15px 30px rgba(112, 144, 176, 0.25)',
};

export const EXTENDED_TRANSITION = {
  height: 'height, max-height, min-height',
  width: 'width, max-width, min-width',
};

export const EXTENDED_DURATION = {
  DEFAULT: '250ms',
  750: '750ms',
  10000: '5000ms',
};

export const EXTENDED_BORDER_RADIUS = {
  xs: '1px',
  sm: '2px',
  DEFAULT: '4px',
  md: '6px',
  lg: '8px',
  xl: '10px',
  '2xl': '12px',
};
export const EXTENDED_SPACING = {
  4.5: '18px',
  5.5: '22px',
  6.5: '26px',
  7.5: '30px',
  8.5: '34px',
  9.5: '38px',
  13: '52px',
  13.5: '54px',
};
